import { ca } from '@cian/analytics';

type TEventCategory = 'LinkIpoteka' | 'BannerIpoteka';
type TEventAction = 'show' | 'click';

export const trackAdFoxMortgage = (action: TEventAction, category: TEventCategory, label: string) => {
  ca('eventSite', {
    name: 'ipotekaevent',
    action,
    category,
    label,
  });
};
